var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "col-12 m-auto" }, [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "shadow" }, [
          _c("img", {
            staticClass: "card-img-top img-fluid",
            staticStyle: { "object-fit": "cover" },
            attrs: {
              src:
                _vm.zoom.media.length > 0
                  ? _vm.zoom.media[0].url
                  : "/images/cover.jpg",
            },
          }),
        ]),
        _vm._v(" "),
        _vm.zoom.description !== null
          ? _c("div", { staticClass: "card-content" }, [
              _c("div", { staticClass: "card-body pt-05 pb-05" }, [
                _c("div", { staticClass: "d-flex" }, [
                  _c("div", [
                    _c("h1", {
                      staticClass: "font-large-1",
                      domProps: { textContent: _vm._s(_vm.zoom.title) },
                    }),
                    _vm._v(" "),
                    _c("h2", { staticClass: "primary font-medium-3 pb-2" }, [
                      _c("span", {
                        domProps: { textContent: _vm._s(_vm.showDateTime) },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "ml-auto pt-1" }, [
                    _c(
                      "div",
                      {
                        staticClass: " badge badge-pill bg-gradient-primary",
                        staticStyle: { padding: "0.2rem 0.5rem" },
                      },
                      [
                        _c("i", { staticClass: "feather icon-video" }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.__("webinar.title_singular")) +
                            "\n                            "
                        ),
                      ]
                    ),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12 col-md-8" }, [
                    _c("h5", { staticClass: "border-bottom pb-05 mb-1" }, [
                      _c("i", { staticClass: "feather icon-book-open" }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.__("webinar.headers.admin.event_detail")) +
                          "\n                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "d-flex justify-content-start" }, [
                      _c("p", [
                        _c("span", { staticClass: "user-name text-bold-600" }, [
                          _c("i", { staticClass: "fa fa-clock" }),
                          _vm._v(
                            " " +
                              _vm._s(_vm.__("webinar.fields.text.timezone")) +
                              ": "
                          ),
                        ]),
                        _c("br"),
                        _vm._v(
                          _vm._s(_vm.zoom.timezone) +
                            "\n                                "
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _c("span", { staticClass: "user-name text-bold-600" }, [
                        _c("i", { staticClass: "fas fa-file-alt" }),
                        _vm._v(
                          " " +
                            _vm._s(_vm.__("webinar.fields.text.description")) +
                            ": "
                        ),
                      ]),
                      _c("br"),
                      _vm._v(" "),
                      _c("span", {
                        staticClass: "breakAll image-resize",
                        domProps: { innerHTML: _vm._s(_vm.zoom.description) },
                      }),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-12 col-md-4" }, [
                    _c("h5", { staticClass: "border-bottom pb-05 mb-1" }, [
                      _c("i", { staticClass: "feather icon-user-plus" }),
                      _vm._v(
                        _vm._s(
                          _vm.__("webinar.headers.admin.event_organiser")
                        ) + "\n                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _c("span", { staticClass: "user-name text-bold-600" }, [
                        _c("i", { staticClass: "fa fa-building" }),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.__("webinar.fields.text.organisation_name")
                            ) +
                            ": "
                        ),
                      ]),
                      _c("br"),
                      _vm._v(_vm._s(_vm.zoom.organisation_name)),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _c("span", { staticClass: "user-name text-bold-600" }, [
                        _c("i", { staticClass: "fa fa-user" }),
                        _vm._v(" " + _vm._s(_vm.__("globals.name")) + ": "),
                      ]),
                      _c("br"),
                      _vm._v(_vm._s(_vm.zoom.contact_name)),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _c("span", { staticClass: "user-name text-bold-600" }, [
                        _c("i", { staticClass: "fa fa-phone" }),
                        _vm._v("  " + _vm._s(_vm.__("globals.phone")) + ": "),
                      ]),
                      _c("br"),
                      _vm._v(
                        _vm._s(_vm.zoom.contact_phone) +
                          "\n                            "
                      ),
                    ]),
                    _vm._v(" "),
                    _c("p", [
                      _c("span", { staticClass: "user-name text-bold-600" }, [
                        _c("i", { staticClass: "fa fa-envelope" }),
                        _vm._v(" " + _vm._s(_vm.__("globals.email")) + ": "),
                      ]),
                      _c("br"),
                      _vm._v(
                        _vm._s(_vm.zoom.contact_email) +
                          "\n                            "
                      ),
                    ]),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "d-flex pr-05 align-items-center border-top pt-1 mt-05",
                  },
                  [
                    _c(
                      "a",
                      {
                        staticClass:
                          "download-button btn btn-primary waves-effect waves-light form-control text-white",
                        attrs: {
                          "data-toggle": "modal",
                          "data-target": "#registerModal",
                        },
                      },
                      [
                        _c("i", { staticClass: "fa fa-calendar" }),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.__("webinar.form.buttons.register_now")
                            ) +
                            " "
                        ),
                      ]
                    ),
                  ]
                ),
              ]),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-flex justify-content-between border-top mb-2" },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "p-1" }, [
              _c(
                "span",
                {
                  attrs: {
                    "data-toggle": "modal",
                    "data-target": "#registerModal",
                  },
                },
                [
                  _c("i", { staticClass: "fa fa-comment-o" }),
                  _vm._v(
                    " " +
                      _vm._s(_vm.__("globals.comment")) +
                      "\n                "
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "p-1" }, [
              _c("div", { staticClass: "dropdown" }, [
                _c(
                  "a",
                  {
                    staticClass: "dropdown-toggle",
                    attrs: {
                      id: "socialShareButton",
                      "data-toggle": "dropdown",
                      "aria-haspopup": "true",
                      "aria-expanded": "false",
                    },
                  },
                  [
                    _c("i", { staticClass: "fa fa-share-alt" }),
                    _vm._v(
                      " " +
                        _vm._s(_vm.__("globals.share")) +
                        "\n                        "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "dropdown-menu",
                    attrs: { "aria-labelledby": "socialShareButton" },
                  },
                  [_c("span", { domProps: { innerHTML: _vm._s(_vm.social) } })]
                ),
              ]),
            ]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "p-1" }, [
      _c("i", {
        staticClass: "fa fa-thumbs-o-up",
        attrs: { "data-toggle": "modal", "data-target": "#registerModal" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }